export default __webpack_public_path__ + "static/ThinkstockPhotos-457417609_article-4398fa5a7fc80d7bade2af1f68c7036a.jpg";